<!--
 * @Author:
 * @Description:步骤3-公司代表
 * @Date: 2024-09-09 14:11:44
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/components/step-companyRepresentative.vue
-->
<template>
  <div class="step_companyRepresentative" v-loading="loading">
    <div>
      <p class="descript1"> {{ $t('message.register.validateBusiness.companyRepresentative.descript1') }}</p>
      <p class="descript2">{{ $t('message.register.validateBusiness.companyRepresentative.descript2') }}</p>
    </div>
    <validation-component ref="validationForm" :validation-condition="validationCondition">
      <div slot="id">
        <template>
          <RhcnUpload title="ID" :fileList="form.uploadPersonalIdImages.fileList.id"
            :on-change="onMaterialItemChange('form', 'uploadPersonalIdImages', 'id')"
            :on-remove="onMaterialItemRemove('form', 'uploadPersonalIdImages', 'id')" :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
      <div slot="passport">
        <template>
          <RhcnUpload :title="$t('message.register.companyRepresentative_desc.passport')"
            :fileList="form.uploadPersonalIdImages.fileList.passport"
            :on-change="onMaterialItemChange('form', 'uploadPersonalIdImages', 'passport')"
            :on-remove="onMaterialItemRemove('form', 'uploadPersonalIdImages', 'passport')" :disabled="isDisabled">
          </RhcnUpload>
        </template>
      </div>
    </validation-component>
    <div class="button-box">
      <el-button type="primary" @click="confirm" size="mini" :disabled="isDisabled">{{ $t('message.exchange.continue')
        }}</el-button>

    </div>
  </div>
</template>

<script>
import { REQUIRED, DATEFORMAT, validateFns } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { businessLocation } from '@/utils/options/networkApplication';
import RhcnUpload from '@/views/account/information/supplement/upload/index.vue';

import mixins from '../../mixins';

export default {
  name: 'StepCompanyRepresentative',
  components: {
    ValidationComponent,
    RhcnUpload,
  },

  mixins: [mixins],
  data() {
    return {
      form: {
        uploadPersonalIdImages: {
          id: '',
          passport: '',
          fileList: {
            id: [],
            passport: [],
          },
        },
      },
      validationCondition: [
        // 名字
        {
          key: 'firstName',
          name: 'message.register.companyRepresentative_desc.legalName',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.companyRepresentative_desc.legalName_firstName',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        // 姓
        {
          key: 'lastName',
          type: 'input',
          defValue: '',

          placeholder: 'message.register.companyRepresentative_desc.legalName_lastName',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'emailAddress',
          name: 'message.register.companyRepresentative_desc.email_address',
          type: 'input',
          defValue: '',
          placeholder: 'executive@company.com',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'wechat',
          name: 'message.register.companyRepresentative_desc.wechat',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.companyRepresentative_desc.wechat_input_placeHolder',
          options: businessLocation,
          isInternationalization: true,
          isShowStar: true,
          rule: [],
        },
        {
          key: 'jobTitle', // 职位
          name: 'message.register.companyRepresentative_desc.job_title',
          type: 'input',
          defValue: '',

          placeholder: 'message.register.companyRepresentative_desc.job_input_tips',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'dateOfBirth', // 出生日期
          name: 'message.register.companyRepresentative_desc.birthDate',
          type: 'input',
          defValue: '',
          placeholder: 'YYYY-MM-DD',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'location', // 所在地
          name: 'message.register.companyRepresentative_desc.home_address',
          type: 'select',
          defValue: this.$attrs.formData.businessType.businessLocation || 'Hong Kong SAR China',
          placeholder: 'message.register.businessTypeTips',
          isInternationalization: true,
          options: businessLocation,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'areaOrCity', // 城市/区域
          type: 'input',
          placeholder: 'message.register.businessDetails.location',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'district', // 地区
          type: 'input',
          defValue: '',
          placeholder: 'message.register.businessDetails.district',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'addressLine1', // 城市/区域
          type: 'input',
          defValue: '',

          placeholder: 'message.register.businessDetails.address_line_1',
          isInternationalization: true,
          options: businessLocation,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'addressLine2',
          type: 'input',
          placeholder: 'message.register.businessDetails.address_line_2',
          isInternationalization: true,
          isShowStar: true,
          defValue: '',
        },
        {
          key: 'postalCode',
          type: 'input',
          placeholder: 'message.register.businessDetails.postal_code',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',

        },
        {
          key: 'phoneNumber',
          name: 'message.register.companyRepresentative_desc.phone_number',
          type: 'input',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
          defValue: '',

        },
        {
          key: 'personalIdNumber',
          name: 'message.register.companyRepresentative_desc.personal_id_numbe',
          type: 'input',
          defValue: '',
          placeholder: 'message.register.companyRepresentative_desc.personal_id_numbe_input_placeHolder',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },
        {
          key: 'uploadPersonalIdImages',
          name: 'message.register.companyRepresentative_desc.birthDUpload_Personal_id_imagesate',
          type: 'slot',
          isShowStar: true,
        },
        {
          key: 'id', // ID
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],

        },
        {
          key: 'passport', // 护照
          type: 'slot',
          defValue: '',
          isInternationalization: true,
          isShowStar: true,
          rule: [REQUIRED],
        },

      ],
    };
  },

  methods: {
    confirm() {
      this.$refs.validationForm.toFormValid((params) => {
        const { firstName, lastName, emailAddress, jobTitle, dateOfBirth, phoneNumber, personalIdNumber, location, areaOrCity, district, addressLine1, addressLine2, postalCode, wechat } = params;
        const {
          uploadPersonalIdImages: {
            id,
            passport,
          },
        } = this.form;
        const businessRepresentative = {
          legalName: {
            firstName,
            lastName,
          },
          wechat,
          emailAddress,
          jobTitle,
          dateOfBirth,
          phoneNumber,
          personalIdNumber,
          homeAddress: {
            location,
            areaOrCity,
            district,
            addressLine1,
            addressLine2,
            postalCode,
          },
          uploadPersonalIdImages: {
            id: id || '',
            passport: passport || '',
          },
        };
        const regExp = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[01])$/;
        if (!regExp.test(dateOfBirth)) {
          this.$message.warning(this.$t('message.validator.dateFormat'));
          return;
        }
        this.$emit('updateFormData', { businessRepresentative, currentStep: 'businessRepresentative', nextStep: 'businessOwners' });
      });
    },
  },
  watch: {
    applicationInfo: {
      handler(applicationInfo) {
        const { businessRepresentative, businessRepresentative: { legalName, homeAddress, uploadPersonalIdImages }, currentStep } = applicationInfo;
        const _data = { ...businessRepresentative, ...legalName, ...homeAddress, ...uploadPersonalIdImages };
        const isDisabled = currentStep === 'status';
        if (isDisabled) {
          this.$refs.validationForm.setItemDisabled('', true, true);
        }
        if (legalName.firstName) {
          ['firstName',
            'lastName',
            'emailAddress',
            'jobTitle',
            'dateOfBirth',
            'phoneNumber',
            'personalIdNumber',
            'location',
            'areaOrCity',
            'district',
            'addressLine1',
            'addressLine2',
            'postalCode',
            'id',
            'passport',
            'wechat',
          ].forEach(key => {
            this.$refs.validationForm.setItemValue(key, _data[key]);
          });
          const arr = [
            'id',
            'passport',
          ];
          arr.forEach(item => {
            this.form.uploadPersonalIdImages[item] = _data[item];
            _data[item] && this.form.uploadPersonalIdImages.fileList[item].push({
              url: _data[item],
              name: '',
            });
          });
          this.$refs.validationForm.toFormValid((params) => {
            const { firstName, lastName, emailAddress, jobTitle, dateOfBirth, phoneNumber, personalIdNumber, location, areaOrCity, district, addressLine1, addressLine2, postalCode, wechat } = params;
            const {
              uploadPersonalIdImages: {
                id,
                passport,
              },
            } = this.form;
            const businessRepresentative = {
              legalName: {
                firstName,
                lastName,
              },
              wechat,
              emailAddress,
              jobTitle,
              dateOfBirth,
              phoneNumber,
              personalIdNumber,
              homeAddress: {
                location,
                areaOrCity,
                district,
                addressLine1,
                addressLine2,
                postalCode,
              },
              uploadPersonalIdImages: {
                id: id || '',
                passport: passport || '',
              },
            };
            this.$emit('onlyUpdateForm', { businessRepresentative, currentStep: 'businessRepresentative' });
          });
        }
      },
      deep: true,
    },
  },

};
</script>

<style scoped lang="scss">
.button-box {
  width: 100%;

  .el-button {
    width: 100% !important;
  }
}
</style>
